<template>
  <div>
    <SnackbarNew
      :snackbar.sync="snackbar"
      :snackbarError="snackbarError"
      :snackbarMessage="snackbarMessage"
    />
    <v-dialog v-model="flag" width="400">
      <v-card tile class="white" :loading="getFetchUrlLoader">
        <template slot="progress">
          <v-progress-linear color="#2a206a" indeterminate></v-progress-linear>
        </template>
        <v-overlay
          :value="getFetchUrlLoader"
          :absolute="absolute"
          v-if="getFetchUrlLoader == true"
        >
        </v-overlay>
        <!-- Title bar -->
        <v-card-title
          class="py-3 px-4 text-truncate dialog-title-border dark-purple-text"
        >
          <div class="d-flex justify-center" style="width: 90%">
            <span>
              <b class="modals-title-size"> Webhook URL </b>
            </span>
          </div>

          <v-spacer></v-spacer>
          <v-icon small color="#757096" @click="closeDialog">mdi-close</v-icon>
        </v-card-title>
        <!-- Url Form -->
        <v-card-text class="mt-5">
          <v-form ref="form">
            <v-text-field
              autocomplete="off"
              color="#2a206a"
              dense
              outlined
              v-model="endPointURL"
              label="End Point URL"
            ></v-text-field>
            <v-autocomplete
              menu-props="closeOnClick"
              color="#2a206a"
              three-line
              dense
              :items="events"
              v-model="selectedEvent"
              outlined
              flat
              solo
              multiple
              item-value="value"
              item-text="value"
              label="Select Events"
              auto-select-first
            >
              <template v-slot:item="{ item }">
                <div class="d-flex" style="width: 200px">
                  <span class="font-size-12 ml-3">
                    {{ item.name }}
                  </span>
                </div>
              </template>
              <template v-slot:selection="{ item, index }">
                <v-chip
                  class="my-1 chip-bg dark-purple-text"
                  small
                  v-if="index < 3"
                >
                  <div class="d-flex align-center font-size-14">
                    <div class="ml-3">{{ item.name }}</div>
                  </div>
                </v-chip>
                <span v-if="index === 3" class="grey--text caption">
                  (+{{ selectedEvent.length - 3 }} others)
                </span>
              </template>
            </v-autocomplete>
          </v-form>
        </v-card-text>

        <!-- save button -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="webHookUrl"
            class="reset-btn text-capitalize"
            color="darken-1"
            tile
            text
            @click="remove()"
            >Remove
          </v-btn>
          <v-btn
            class="white--text btn-success text-capitalize"
            color="darken-1"
            text
            tile
            @click="save()"
            :loading="loader"
            >Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { snackbarMixin } from "@/mixins/snackbarMixin";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      flag: true,
      selectedEvent: [],
      endPointURL: null,
      absolute: true,
      loader: false,
      webHookUrl: null,
      events: [
        { name: "Task assigned", value: "task_assigned" },
        { name: "Task unassigned", value: "task_unassigned" },
        { name: "Comment added", value: "task_comment" },
        { name: "Task completed", value: "task_completed" },
        { name: "Invitation accepted", value: "invitation_accepted" },
      ],
    };
  },
  props: ["openWebhookModal"],
  mixins: [snackbarMixin],
  computed: {
    ...mapGetters(["getSelectedCompany", "getFetchUrlLoader"]),
  },
  components: {
    SnackbarNew: () => import("@/components/Includes/SnackbarNew"),
  },
  watch: {
    flag(value) {
      !value ? this.$emit("update:openWebhookModal", false) : () => {};
    },
  },
  methods: {
    closeDialog() {
      this.$emit("update:openWebhookModal", false);
    },
    remove() {
      Swal.fire({
        title: "Remove Webhook URL",
        html: "Are you sure you want to remove webhook url?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("resetWebhookUrl")
            .then((response) => {
              if (response.status == 200) {
                this.closeDialog();
              }
            })
            .catch((error) => {
              this.openSnackbar(true,error.response.data.message);
            });
        }
      });
    },
    save() {
      if (this.validateURL()) {
        this.loader = true;
        let data = {
          url: this.endPointURL,
          task_assigned: this.selectedEvent.find((item) => {
            return item == "task_assigned";
          })
            ? true
            : false,
          task_unassigned: this.selectedEvent.find((item) => {
            return item == "task_unassigned";
          })
            ? true
            : false,
          task_completed: this.selectedEvent.find((item) => {
            return item == "task_completed";
          })
            ? true
            : false,
          task_comment: this.selectedEvent.find((item) => {
            return item == "task_comment";
          })
            ? true
            : false,
          invitation_accepted: this.selectedEvent.find((item) => {
            return item == "invitation_accepted";
          })
            ? true
            : false,
        };

        this.$store
          .dispatch("addWebHookUrl", data)
          .then(() => {
            this.openSnackbar(false, "Url Updated Successfully");
            this.loader = false;
            this.closeDialog();
          })
          .catch(() => {
            this.loader = false;
          });
      } else {
        return false;
      }
    },
    validateURL() {
      if (
        /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi.test(
          this.endPointURL
        )
      ) {
        return true;
      } else {
        this.openSnackbar(true, "Kindly give correct URL");
        return false;
      }
    },
  },
  mounted() {
    this.$store.dispatch("fetchWebhookUrl").then((response) => {
      for (let key in response.data.data) {
        if (response.data.data[key]) {
          if (key != "url") {
            this.selectedEvent.push(key);
          }
        }
      }
      this.endPointURL = response.data.data.url;
      this.webHookUrl = response.data.data.url;
      this.$store.commit("setFetchUrlLoader", false);
    });
  },
};
</script>
<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: #dcd8f3;
}
.v-autocomplete__content.v-menu__content .v-select-list {
  border-radius: 0 0 4px 4px;
  max-height: 136px;
  overflow: scroll;
}
</style>
<style>
.v-application .primary--text {
  color: #1cc283 !important;
  caret-color: #e9fcf5 !important;
}
</style>
